import { IconProps } from './icons';

export const ListCheckIcon = ({ color = '#0085FF', height = 22, width = 18 }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 22" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4142 0.383301H2C0.89543 0.383301 0 1.24268 0 2.30279V19.5781C0 20.6383 0.89543 21.4976 2 21.4976H16C17.1046 21.4976 18 20.6383 18 19.5781V5.74422L12.4142 0.383301ZM2 2.30279H10V6.14176C10 7.20186 10.8954 8.06124 12 8.06124H16V19.5781H2V2.30279ZM12 6.14176V2.70032L15.5858 6.14176H12ZM12.2929 10.2618L8 14.3819L5.70711 12.1813L4.29289 13.5386L8 17.0965L13.7071 11.6191L12.2929 10.2618Z"
        fill={color}
      />
    </svg>
  );
};
